import React from "react";
import { createBrowserRouter } from "react-router-dom";
import DashboardPage from "../page/Dashboard.jsx";
import Signup from "../page/SignUp.jsx";
import Search from "../page/Search.jsx";
export const RoutesPath = {
  DASHBOARD: "dashboard",
  SIGNUP: "signup",
  SEARCH: "search",
};
export const browserRouter = createBrowserRouter([
  {
    path: "/",
    element: <DashboardPage />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/member/:studentId",
    element: (
      <div>
        This feature is still in progress. On click of a column, this page
        should display full info of that student. Click back button to go back
        to previous page.
      </div>
    ),
  },
  {
    path: "/login/callback",
    element: <div>some route 3</div>,
  },
  {
    path: "/*",
    element: <p>Opps!, We can't find the page you are looking for.</p>,
  },
]);
